import bcLogo from './bc-logo.svg';

export const BCLogoSVG = bcLogo;
